import { Fade, Slide } from "react-awesome-reveal";
import IconDescription from "../../../../components/ui/icon-description/icon-description";

import "./choose-us.scss";

type ChooseUsPropsT = {
  title: string;
  img: string;
  altImg: string;
  isMobile: boolean;
};

const elements: {
  title: string;
  textMb: string; //mobile
  textDsk: string; //desktop
  icon: string;
  type: "primary" | "secondary";
}[] = [
  {
    title: "Sicurezza Garantita",
    textMb: "Tecnologie non invasive per massima sicurezza in cantiere.",
    textDsk:
      "Tecnologie non invasive che garantiscono la massima sicurezza in cantiere e per le strutture esistenti.",
    icon: "shield",
    type: "primary",
  },
  {
    title: "Esperienza Consolidata",
    textMb: "Anni di esperienza con centinaia di progetti realizzati.",
    textDsk:
      "Anni di esperienza nell'esecuzione di opere di fondazione e consolidamento con centinaia di progetti realizzati con successo.",
    icon: "award",
    type: "secondary",
  },
  {
    title: "Tecnologie Avanzate",
    textMb: "Moderne attrezzature per risultati ottimali.",
    textDsk:
      "Utilizziamo le più moderne attrezzature e tecniche per garantire risultati ottimali.",
    icon: "rocket",
    type: "secondary",
  },
];

const ChooseUs = ({ title, img, altImg, isMobile }: ChooseUsPropsT) => {
  return (
    <section className="choose-us">
      <div className="choose-us__description-section">
        <Fade direction="up" triggerOnce duration={700} delay={300}>
          <h2 className="choose-us__title">{title}</h2>
        </Fade>
        <Slide
          direction={isMobile ? "up" : "left"}
          triggerOnce
          duration={800}
          cascade
          damping={0.15}
        >
          <div className="choose-us__elements-list">
            {elements.map((el, i) => (
              <div className="choose-us__element" key={`${i}-${el.title}`}>
                <IconDescription
                  icon={el.icon}
                  title={el.title}
                  text={isMobile ? el.textMb : el.textDsk}
                  type={el.type}
                  size="medium"
                />
              </div>
            ))}
          </div>
        </Slide>
      </div>

      <div className="choose-us__image-section">
        <Fade direction={isMobile ? "up" : "right"} triggerOnce duration={1000}>
          <img className="choose-us__img" src={img} alt={altImg} />
        </Fade>
      </div>
    </section>
  );
};

export default ChooseUs;
